<template>
  <div class="recommond-wrap">
    <!-- <div class="recommond-text">推荐</div>
    <div class="tags-warp">
      <span class="tag-test">蜀绣</span>
      <span class="tag-test">蜀绣</span>
      <span class="tag-test">蜀绣</span>
      <span class="tag-test">蜀绣</span>
      <span class="tag-test">蜀绣</span>
      <span class="tag-test">范德萨发</span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  // 计算属性
  computed: {},

  // 数据监听
  watch: {},

  // 自定义方法
  methods: {},

  // 刚创建vue实例完毕
  created() {},

  // 刚挂载完毕
  mounted() {},
};
</script>
<style lang="scss" scoped>
.recommond-wrap {
  width: 100%;
  margin-top: 118px;
  .recommond-text {
    text-align: left;
  }
  .tags-warp {
    display: flex;
    flex-wrap: wrap;
    line-height: 28px;
    font-size: 14px;
    color: #0ed7e1;
    .tag-test {
      font-weight: 400;
      margin-top: 12px;
      margin-right: 15px;
      padding: 0 20px;
      background-color: rgba(14, 215, 225, 0.1);
      border-radius: 999px;
    }
  }
}
</style>
